// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root___r8kE","notes":"Notes_notes__PqScF","note":"Notes_note__12gtV","markdown":"Notes_markdown__11K3E"};